/**
 * U1 (décision 490) — qui a pris en charge la confirmation d'une fiche, et
 * depuis quand (R2).
 */
import { z } from 'zod';
export const schemaPriseEnCharge = z.object({
    par: z.object({ id: z.uuid(), nom: z.string(), prenom: z.string() }),
    depuis: z.iso.datetime(),
});
/** Sur la fiche : la prise en cours, et ce que le lecteur peut en faire. */
export const schemaPriseEnChargeDeLaFiche = z.object({
    priseEnCharge: schemaPriseEnCharge.nullable(),
    /** La fiche attend encore la chargée : on peut la prendre, la relâcher, la reprendre. */
    aConfirmer: z.boolean(),
    aMoi: z.boolean(),
    /** R3 — l'encadrement reprend une prise en charge tenue par un autre. */
    peutReprendre: z.boolean(),
});
//# sourceMappingURL=prise-en-charge.js.map